// http://stackoverflow.com/a/17535903
// http://stackoverflow.com/questions/14782439/removing-angularjs-currency-filter-decimal-cents
angular.module('b2bLoginApp.filters').filter('noFractionCurrency',
    ["$filter", "$locale", function ($filter, $locale) {
        var currency = $filter('currency'), formats = $locale.NUMBER_FORMATS;
        return function (amount, symbol) {
            var value = currency(amount, symbol);
            return value.replace(new RegExp('\\' + formats.DECIMAL_SEP + '\\d{2}'), '');
        };
    }]);
